if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        this.querySelectorAll('[data-product-modal-prev], [data-product-modal-next]').forEach((button) => {
          button.addEventListener('pointerup', (event) => event.stopPropagation());
        });
        this.querySelector('[data-product-modal-prev]')?.addEventListener('click', this.showSiblingMedia.bind(this, -1));
        this.querySelector('[data-product-modal-next]')?.addEventListener('click', this.showSiblingMedia.bind(this, 1));
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.preloadModalImages();
        this.showActiveMedia();
      }

      preloadModalImages() {
        this.querySelectorAll('.product-media-modal__content img').forEach((image) => {
          image.loading = 'eager';
          if (image.decode) image.decode().catch(() => {});
        });
      }

      showActiveMedia() {
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }

      showSiblingMedia(direction, event) {
        event?.stopPropagation();
        const mediaItems = Array.from(this.querySelectorAll('.product-media-modal__content > [data-media-id]')).filter(
          (item) => !item.classList.contains('product__media-item--variant')
        );
        if (!mediaItems.length) return;

        const activeMedia = this.querySelector('.product-media-modal__content > [data-media-id].active') || mediaItems[0];
        const activeIndex = Math.max(mediaItems.indexOf(activeMedia), 0);
        const nextIndex = (activeIndex + direction + mediaItems.length) % mediaItems.length;

        activeMedia.classList.remove('active');
        mediaItems[nextIndex].classList.add('active');
        this.playModalMedia(mediaItems[nextIndex]);
      }

      playModalMedia(activeMedia) {
        window.pauseAllMedia();
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }
    }
  );
}
